import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from 'recharts';
const BarCharts = ({data, dataKey}) => {
  return (
    <ResponsiveContainer height={250}>
      <BarChart
        data={data}
        margin={{
          top: 0,
          right: 0,
          left: 0,
          bottom: 0
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip shared={false}/>
        {/* <Legend /> */}
        <Bar background={{ radius: 10}} dataKey={dataKey} stackId="a" fill="#3E66FB" radius={10} barSize={30}>
        </Bar>
        {/* <Bar dataKey="value2" stackId="a" fill="#E4E4E4" radius={10} barSize={30}/> */}
      </BarChart>
    </ResponsiveContainer>
  );
}

export default BarCharts;
